import queryString from 'query-string';
import { MetaField } from '@rossum/api-client/shared';
import { SupportedAnnotationView } from '../supportedAnnotationViews';
import { LevelOptions, ViewOptions } from '../types';

type DataGridOperators =
  | 'isEmpty'
  | 'isNotEmpty'
  | 'contains'
  | 'equals'
  | 'startsWith'
  | 'isAnyOf'
  | 'notIn'
  | 'is'
  | 'not'
  | 'after'
  | 'onOrAfter'
  | 'before'
  | 'onOrBefore'
  | '='
  | '!='
  | '>'
  | '>='
  | '<'
  | '<=';

export const generateDocumentListUrl = (
  query: Partial<{
    level: LevelOptions;
    view: ViewOptions;
    page: number;
    page_size: number;
    ordering: string;
    selected_annotation: number;
    selected_annotation_view: SupportedAnnotationView;

    filtering: Array<{
      field: MetaField | (string & Record<string, unknown>);
      operator: DataGridOperators;
      value: unknown;
    }>;
  }>
) => {
  const stringifiedQuery = queryString.stringify({
    ...query,
    filtering: query.filtering
      ? JSON.stringify({ items: query.filtering, logicOperator: 'and' })
      : undefined,
  });

  return `/documents?${stringifiedQuery}`;
};
